import { AvatarSize, Icon, Text } from '@bechtel/gds';
import { FC } from 'react';
import { AvatarPlaceholderStyled, AvatarSectionStyled } from './styled';

export interface AvatarPlaceholderProps {
  nameFirst?: string;
  showIcon?: boolean;
  nameLast?: string;
  size?: AvatarSize;
}

export const AvatarPlaceholder: FC<AvatarPlaceholderProps> = ({ size, nameFirst, nameLast, showIcon }) => {
  return (
    <AvatarSectionStyled size={size}>
      <AvatarPlaceholderStyled showIcon={showIcon}>
        {showIcon ? (
          <Icon fillColor="grey.400" icon="user" iconStyle="solid" />
        ) : (
          <Text size="250">
            {nameFirst?.slice(0, 1)}
            {nameLast?.slice(0, 1)}
          </Text>
        )}
      </AvatarPlaceholderStyled>
    </AvatarSectionStyled>
  );
};
